import { useDocumentMeta } from "@/hooks/useDocumentMeta";
import HeroCarousel from "@/pages/home/components/HeroCarousel";
import CategoryQuickLinks from "@/pages/home/components/CategoryQuickLinks";
import LatestVideosSection from "@/pages/home/components/LatestVideosSection";
import HotRanking from "@/pages/home/components/HotRanking";
import AboutSection from "@/pages/home/components/AboutSection";

export default function Home() {
  useDocumentMeta({
    title: "逼特逼视频-多样视频内容聚合平台",
    description:
      "逼特逼视频提供丰富的视频内容，包括影视剪辑、短视频和用户创作作品，覆盖多种类型，满足用户多样化观看需求。",
    keywords: "逼特逼视频,视频平台,短视频,影视剪辑,高清视频,视频分享,在线视频,视频推荐",
  });

  return (
    <div className="mx-auto w-full max-w-[1440px] px-4 pb-4 md:px-8">
      <section className="pb-6 pt-8 md:pt-10">
        <h1 className="font-heading text-3xl font-bold text-foreground-950 md:text-4xl">
          逼特逼视频
        </h1>
        <p className="mt-2 text-sm text-foreground-600 md:text-base">
          多样视频内容聚合平台 · 影视剪辑 / 短视频 / 用户作品，一站看个够
        </p>
      </section>

      <HeroCarousel />

      <CategoryQuickLinks />

      <div className="mt-12 grid grid-cols-1 gap-8 lg:grid-cols-3">
        <div className="lg:col-span-2">
          <LatestVideosSection />
        </div>
        <div className="lg:col-span-1">
          <HotRanking />
        </div>
      </div>

      <AboutSection />
    </div>
  );
}